/**
 * @generated SignedSource<<9300299525f528ef70041e8a4735b6fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommonSpaceNavigationContent_space$data = {
  readonly didContainUserContent: boolean;
  readonly homepage: {
    readonly id: string | null;
  } | null;
  readonly id: string | null;
  readonly key: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceOperationsFragment">;
  readonly " $fragmentType": "CommonSpaceNavigationContent_space";
};
export type CommonSpaceNavigationContent_space$key = {
  readonly " $data"?: CommonSpaceNavigationContent_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommonSpaceNavigationContent_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommonSpaceNavigationContent_space",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SpaceOperationsFragment"
    },
    {
      "kind": "ScalarField",
      "name": "didContainUserContent"
    }
  ],
  "type": "Space"
};
})();

(node as any).hash = "df35b90fbfa838a0cb8503ca2715a1c6";

export default node;
